<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Membership</h1>

      <section v-if="loading" class="loading-section">
        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
      </section>

      <div v-else-if="validMembershipForm">
        <p>
          To view the current membership form, <a :href="membership.membership_file" target="_blank">click here</a>.
        </p>
      </div>
      <div v-else-if="!validMembershipForm">
        <p>
          There is no membership form available. Check back later.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import MembershipAPI from '@/services/api/Membership';

export default {
  name: 'MembershipPage',
  data() {
    return {
      loading: true,
      membership: {},
      validMembershipForm: false,
    };
  },
  mounted() {
    MembershipAPI.getMembershipFormLink()
      .then(membership => {
        if (!_.isEmpty(membership)) {
          this.membership = membership[0];
          this.validMembershipForm = true;
        } else {
          this.membership = {};
          this.validMembershipForm = false;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
</style>
